import GridCellBoolean from '../message-center/GridCellBoolean';
import { IColumn } from '../message-center/GridColumns';

export const TrashBinColumns: IColumn[] = [
  {
    field: 'location.name',
    title: 'Location',
    width: '250px',
    notFilterable: true,
    show: true,
    alwaysVisible: true,
    orderIndex: 1,
  },
  {
    field: 'title',
    title: 'Message Title',
    width: '160px',
    show: true,
    alwaysVisible: true,
    orderIndex: 2,
  },
  {
    field: 'id',
    title: 'Message ID',
    width: '145px',
    show: true,
    alwaysVisible: true,
    orderIndex: 3,
  },
  {
    field: 'messageType',
    title: 'Message Type',
    width: '160px',
    show: true,
    alwaysVisible: true,
    orderIndex: 4,
  },
  {
    field: 'beginDate',
    title: 'Begin Date',
    width: '145px',
    filter: 'date',
    twoFilterCriteria: true,
    show: true,
    alwaysVisible: true,
    orderIndex: 5,
  },
  {
    field: 'endDate',
    title: 'End Date',
    width: '130px',
    filter: 'date',
    twoFilterCriteria: true,
    show: true,
    alwaysVisible: true,
    orderIndex: 6,
  },
  {
    field: 'primaryKey',
    title: 'Unique ID',
    width: '140px',
    show: true,
    alwaysVisible: true,
    orderIndex: 7,
  },
  {
    field: 'forceHardcopy',
    title: 'Hardcopy',
    width: '135px',
    filter: 'boolean',
    show: true,
    alwaysVisible: false,
    orderIndex: 8,
  },
  {
    field: 'isRequired',
    title: 'Required',
    width: '130px',
    filter: 'boolean',
    cell: GridCellBoolean,
    show: true,
    alwaysVisible: true,
    orderIndex: 9,
  },
  {
    field: 'isOverflowAllowed',
    title: 'Overflow',
    width: '130px',
    filter: 'boolean',
    show: true,
    alwaysVisible: false,
    orderIndex: 10,
  },

  {
    field: 'creator',
    title: 'Creator',
    width: '120px',
    show: true,
    alwaysVisible: false,
    orderIndex: 11,
  },
  {
    field: 'createDate',
    title: 'Create Date',
    width: '110px',
    filter: 'date',
    twoFilterCriteria: true,
    show: true,
    alwaysVisible: false,
    orderIndex: 12,
  },
  {
    field: 'approver',
    title: 'Approver',
    width: '135px',
    show: true,
    alwaysVisible: false,
    orderIndex: 13,
  },
  {
    field: 'approvalDate',
    title: 'Approval Date',
    width: '160px',
    filter: 'date',
    twoFilterCriteria: true,
    show: true,
    alwaysVisible: false,
    orderIndex: 14,
  },
  {
    field: 'lastUpdate',
    title: 'Deleted By',
    width: '160px',
    show: true,
    notFilterable: true,
    alwaysVisible: false,
    orderIndex: 15,
  },
  {
    field: 'deletionDate',
    title: 'Deletion Date',
    width: '160px',
    filter: 'date',
    notFilterable: true,
    twoFilterCriteria: true,
    show: true,
    alwaysVisible: false,
    orderIndex: 16,
  },
];
